module.exports = __webpack_public_path__ + "img/light_4.42ad8aee.png";